import { render, staticRenderFns } from "./Typography6.vue?vue&type=template&id=33285db4&scoped=true"
import script from "./Typography6.vue?vue&type=script&lang=js"
export * from "./Typography6.vue?vue&type=script&lang=js"
import style0 from "./Typography6.vue?vue&type=style&index=0&id=33285db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33285db4",
  null
  
)

export default component.exports